import React, { useState } from "react";
import TableComponent from "../../../components/TableComponent/TableComponentFiltro";

export const Multas = () => {
  const cabeceras = [
    "Id", //0
    "Nombre", //1
    "Editar",
    "Eliminar",
  ];
  const [parametros] = useState({
    action: "datatable",
    table: "types_penaltys",
    rows: "keyTypePenalty,namePenalty", ///sin espacios y comas
    conditions: "enabled = 1",
    page: 0,
    records: 5,
    search: "",
    order: "",
  });

  return (
    <div>
      <TableComponent
        titulo="Tipos de Sanciones"
        cabecerasTabla={cabeceras}
        filtro={null}
        rutaCrear="/template/sanciones-nomina/crear"
        rutaEditar="/template/sanciones-nomina/editar"
        parametros={parametros}
      ></TableComponent>
    </div>
  );
};
export default Multas;
